import { render, staticRenderFns } from "./FileFormModal.vue?vue&type=template&id=11a6a146"
import script from "./FileFormModal.vue?vue&type=script&lang=js"
export * from "./FileFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports